import React from 'react';
import {useTranslation} from 'react-i18next';
import {useSnackbar} from 'notistack';
import {
  DialogTitle,
  DialogContent,
  DialogActions,
  Dialog,
  TextField
} from '@mui/material';

import {addNewADGroup} from '@shared/services/service-handlers/PrivateService';

import {APP} from 'src/styles/variables';
import SnackBarConfig from '@components/snackbar/SnackbarConfig';
import {getErrorMessage} from '@shared/utils/ErrorUtils';
import {useAppContext} from '@context/AppContext';
import {LoadingButton} from '@mui/lab';

const AdGroupsAddDialog = (props: any): React.ReactElement => {
  const {t} = useTranslation();
  const {enqueueSnackbar} = useSnackbar();
  const {onClose, open, ...other} = props;

  const [loaders, setLoaders] = React.useState<boolean>(false);
  const [groupName, setGroupName] = React.useState('');
  const {
    appState: {applicationName}
  } = useAppContext();

  const handleChange = (event: {
    target: {value: React.SetStateAction<string>};
  }) => {
    setGroupName(event.target.value); // Every time the TextField changes, update the state
  };

  const handleCancel = (id?: any) => {
    onClose(id);
  };

  const handleSubmit = async () => {
    try {
      setLoaders(true);
      const res = await addNewADGroup(
        {
          group_name: groupName
        },
        applicationName
      );
      enqueueSnackbar(res?.message, SnackBarConfig.getSuccess());
      setLoaders(false);
      handleCancel(res?.data?.id);
    } catch (error) {
      setLoaders(false);
      const errMessage = getErrorMessage(error);
      enqueueSnackbar(errMessage, SnackBarConfig.getError());
    }
  };

  return (
    <Dialog
      sx={{'& .MuiDialog-paper': {width: '80%', maxHeight: 435}}}
      maxWidth="xs"
      open={open}
      {...other}>
      <DialogTitle
        sx={{
          fontWeight: '700',
          color: APP.PALETTE.APP_BAR_COLOR.INFO_CHIP,
          fontSize: '1rem !important'
        }}>
        {t('PRIVATE.USER_GROUPS.ADD_GROUP', {ns: 'private'})}
      </DialogTitle>

      <DialogContent dividers>
        <TextField
          label="Group Name"
          placeholder="Enter Group Name"
          value={groupName}
          fullWidth
          onChange={handleChange}
        />
      </DialogContent>

      <DialogActions>
        <LoadingButton
          type="submit"
          variant="outlined"
          disabled={loaders}
          color="error"
          sx={{
            mr: 1
          }}
          onClick={handleCancel}>
          {t('PRIVATE.ROLES.CANCEL', {ns: 'private'})}
        </LoadingButton>
        <LoadingButton
          type="submit"
          loading={loaders}
          variant="contained"
          disabled={loaders}
          color="info"
          sx={{
            mr: 1
          }}
          onClick={handleSubmit}>
          {t('PRIVATE.ROLES.SAVE_ROLE', {ns: 'private'})}
        </LoadingButton>
      </DialogActions>
    </Dialog>
  );
};
export default AdGroupsAddDialog;
